// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../procollege/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../procollege/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#procollege_desktop2 p.courses{padding:0;margin:0}`, "",{"version":3,"sources":["webpack://./../blocks/psm_desktop2/widgets/myCourses/widget.vue"],"names":[],"mappings":"AAEE,+BACE,SAAA,CACA,QAAA","sourcesContent":["\n#procollege_desktop2 {\n  p.courses {\n    padding: 0;\n    margin: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
